import type { Model } from '../../../data/models.ts'

export interface BotsCategoryConfig {
	slug: Exclude<Model['category'], 'text'>
	title: string
	tabLabel: string
	path: string
	description: string
	canonical: string
	comingSoon?: boolean
}

export const BOTS_CATEGORIES = {
	image: {
		slug: 'image',
		// Заголовок каталога стилей раздела /bots/images (вкладка «Фотостудия»).
		title: 'Фотостудия',
		tabLabel: 'Изображения',
		path: '/bots/images',
		description:
			'Создавайте изображения с помощью нейросетей: Midjourney, Flux, Nano Banana, Stable Diffusion и другие.',
		canonical: 'https://umnik.ai/bots/images',
	},
	video: {
		slug: 'video',
		title: 'Генерация видео',
		tabLabel: 'Видео',
		path: '/bots/video',
		description:
			'Создавайте видео с помощью нейросетей: Kling, Sora, Runway, Hailuo, Veo, Seedance и другие.',
		canonical: 'https://umnik.ai/bots/video',
	},
	audio: {
		slug: 'audio',
		title: 'Генерация аудио',
		tabLabel: 'Аудио',
		path: '/bots/audio',
		description: 'Генерация музыки, озвучка текста и работа с аудио с помощью нейросетей.',
		canonical: 'https://umnik.ai/bots/audio',
	},
	presentation: {
		slug: 'presentation',
		title: 'Презентации',
		tabLabel: 'Презентации',
		path: '/bots/tools/slides',
		description: 'Создание презентаций нейросетью: опишите тему — AI соберёт слайды с дизайном и картинками.',
		canonical: 'https://umnik.ai/bots/tools/slides',
	},
} satisfies Record<string, BotsCategoryConfig>

export const BOTS_CATEGORIES_LIST = Object.values(BOTS_CATEGORIES)

// Без «Все»: решение владельца 2026-08-13 — дефолтный раздел витрин теперь
// «Популярные» (кураторский фильтр slug=popular), а полный несегментированный
// список карточек из UI убран.
export const BOTS_MAIN_FALLBACK_CATEGORIES = [
	{ id: 'text', name: 'Текст' },
	...BOTS_CATEGORIES_LIST.map((category) => ({
		id: category.slug,
		name: category.tabLabel,
	})),
]

/** Слаг кураторского фильтра «Популярные» (level 1, admin: Настройки →
 *  Все нейросети). Состав — назначениями моделей фильтру; фильтрация витрин
 *  по назначениям, а не по model.category. */
export const POPULAR_FILTER_SLUG = 'popular'
